import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      padding: 32,
      paddingBottom: 24,
    },
    titlePage: {
      fontSize: "28px",
      fontWeight: "bold",
      lineHeight: "38px",
      marginLeft: "8px",
    },
  })
);
